import { createContext, type RefObject } from 'react';

export interface IMonitorFullscreen {
  fullscreen: boolean;
  toggle(): void;
  /** The toggle moves between the card and the top bar, so focus follows it. */
  toggleRef: RefObject<HTMLButtonElement | null>;
}

/** The Monitor page's fullscreen; absent where a building card renders outside the page. */
export const MonitorFullscreenContext = createContext<IMonitorFullscreen | null>(null);
